import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { READ_VACANCIES_LIST, READ_VACANCY, VACANCY_PATH } from 'domain/recruiting/vacancy/shared/vacancyService';
import VacanciesList from 'domain/recruiting/vacancy/List';
import VacancyContext from 'domain/recruiting/vacancy/VacancyContext';
import ViewVacancy from 'domain/recruiting/vacancy/Show';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';

const useVacancyRoute = () => {
  const routers = createRoute({ listRoute: VACANCY_PATH });

  return {
    ...routers,
    copyEntityRoute: `${routers.singleEntityRoute}/copy`,
  };
};

const VacancyRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = useVacancyRoute();

  return (
    <ProtectedRouter basePath={VACANCY_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_VACANCIES_LIST}>
              <VacanciesList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <VacancyContext permissionToCheck={READ_VACANCY}>
              <ViewVacancy />
            </VacancyContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

VacancyRouter.getRouterPath = () => `${VACANCY_PATH}/*`;

export default VacancyRouter;
